import i18n from "../../public/lang/index";
export default {
    ...i18n.t("message.ErrorMessage"),
    "REQUEST_TOO_FREQUENTLY": i18n.t("message.ErrorMessage.REQUEST_TOO_FREQUENTLY"),
    "PARAMETER_NOT_VALID": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "CAPTCHA_HAS_EXPIRED": i18n.t("message.ErrorMessage.CAPTCHA_HAS_EXPIRED"),
    "CAPTCHA_VERIFY_FAILED": i18n.t("message.ErrorMessage.CAPTCHA_VERIFY_FAILED"),
    "CAPTCHA_NOT_FOUND": i18n.t("message.ErrorMessage.CAPTCHA_NOT_FOUND"),
    "CHECKAPPLICANTDRAW": i18n.t("message.ErrorMessage.CHECKAPPLICANTDRAW"),
    "CAPTCHA_IS_MISMATCH": i18n.t("message.ErrorMessage.CAPTCHA_IS_MISMATCH"),
    "ILLEGAL_STATUS": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "SP_SERVICE_EXEC_FAILURE": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "UNSUPPORTED_SERVICE_TYPE": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "OUTPUT_RESULT_IS_EMPTY": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "SERVICE_TYPE_NOT_FOUND": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "DRIVER_NOT_FOUND": i18n.t("message.ErrorMessage.DRIVER_NOT_FOUND"),
    "NO_RESULT": i18n.t("message.ErrorMessage.NO_RESULT"),
    "MOBILE_MISMATCH": i18n.t("message.ErrorMessage.MOBILE_MISMATCH"),
    "VSS_SERVICE_EXEC_FAILURE": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "SESSION_IS_REQUIRED": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "MOBILE_IS_MISMATCH": i18n.t("message.ErrorMessage.MOBILE_IS_MISMATCH"),
    "COACH_APPLICATION_NOT_FOUND": i18n.t("message.ErrorMessage.COACH_APPLICATION_NOT_FOUND"),
    "HEAD_APPLICATION_NOT_FOUND": i18n.t("message.ErrorMessage.HEAD_APPLICATION_NOT_FOUND"),
    "SCHOOL_APPLICATION_NOT_FOUND": i18n.t("message.ErrorMessage.SCHOOL_APPLICATION_NOT_FOUND"),
    "ACCESS_DENIED": i18n.t("message.ErrorMessage.ACCESS_DENIED"),
    "APPROVALING_APPLICATION": i18n.t("message.ErrorMessage.APPROVALING_APPLICATION"),
    "APPLICATION_UNKNOW": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
    "DOCUMENT_TYPE_MUST_REQUIRED": i18n.t("message.ErrorMessage.DOCUMENT_TYPE_MUST_REQUIRED"),
    "TAXI_CERT_NO_ERROR": i18n.t("message.ErrorMessage.TAXI_CERT_NO_ERROR"),
    "D02": i18n.t("message.ErrorMessage.D02"),
    "PAYMENT_TIME_TIME_OUT": i18n.t("message.ErrorMessage.PAYMENT_TIME_TIME_OUT"),
    "LIC_NO_NOT_BE_NULL": i18n.t("message.ErrorMessage.LIC_NO_NOT_BE_NULL"),
    "PHOTO_NO_ERROR": i18n.t("message.ErrorMessage.PHOTO_NO_ERROR"),
    "DOWNLOAD_ERROR": i18n.t("message.ErrorMessage.DOWNLOAD_ERROR"),
    "PAYMENT_STATUS_ERROR": i18n.t('message.ErrorMessage.PAYMENT_STATUS_ERROR'),
    "TRANSACTION_NO_DUPLICATE": i18n.t('message.ErrorMessage.PAYMENT_STATUS_ERROR'),
    "DUPLICATE_APPROVING_APPLICATION": i18n.t('message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION'),
    "CHECK_FAIL": i18n.t('message.ErrorMessage.CHECK_FAIL'),
    "SYSTEM_TIMEOUT": i18n.t("message.ErrorMessage.SYSTEM_BUSY"),
            
    // 預約
    "BUSINESS_NOT_FOUND": i18n.t("message.ErrorMessage.BUSINESS_NOT_FOUND"),
    "PLAN_DURATION_NOT_FOUND": i18n.t("message.ErrorMessage.PLAN_DURATION_NOT_FOUND"),
    "OVER_BUSINESS_APPLACATION_TIMES": i18n.t("message.ErrorMessage.OVER_BUSINESS_APPLACATION_TIMES"),
    "OVER_BUSINESS_NUM": i18n.t("message.ErrorMessage.OVER_BUSINESS_NUM"),
    "APPLICATION_DETAILS_NOT_FOUND": i18n.t("message.ErrorMessage.APPLICATION_DETAILS_NOT_FOUND"),
    "APPLICATION_NOT_FOUND": i18n.t("message.ErrorMessage.APPLICATION_NOT_FOUND"),
    "APPLICATION_DETAILS_IS_REQUIRED": i18n.t("message.ErrorMessage.APPLICATION_DETAILS_IS_REQUIRED"),
    "BOOKING_DATE_ILLEGAL": i18n.t("message.ErrorMessage.BOOKING_DATE_ILLEGAL"),
    "PLAN_NOT_FOUND": i18n.t("message.ErrorMessage.PLAN_NOT_FOUND"),
    "DETAIL_TIME_HAVE_OVERLAP": i18n.t("message.ErrorMessage.DETAIL_TIME_HAVE_OVERLAP"),
    "DURATION_ONLY": i18n.t("message.ErrorMessage.DURATION_ONLY"),
    "BREACH_APPLICATION_UPDATE_LIMIT": i18n.t("message.ErrorMessage.BREACH_APPLICATION_UPDATE_LIMIT"),
    "BREACH_APPLICATION_CANEL_LIMIT": i18n.t("message.ErrorMessage.BREACH_APPLICATION_CANEL_LIMIT"),
    "APPROVAL_INFO_NULL": i18n.t("message.ErrorMessage.APPROVAL_INFO_NULL"),
    "IN_MAINTENANCE_TIME": i18n.t("message.ErrorMessage.IN_MAINTENANCE_TIME"),
    "OVER_CANCEL_TIME": i18n.t("message.ErrorMessage.OVER_CANCEL_TIME"),
    "CANCEL_NUM_LIMIT": i18n.t("message.ErrorMessage.CANCEL_NUM_LIMIT"),
    "OVER_BOOKING_TIME": i18n.t("message.ErrorMessage.OVER_BOOKING_TIME"),
}